import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule } from '@angular/forms';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { SendMailComponent } from './send-mail.component';
import { PipeModule } from '../../pipes';
import { FilterPipe, InputMailListComponent } from './inputmail-list/inputmail-list.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DateModule } from '../../date';
import { GEDModule } from '../../gestion-electronique-documents';

@NgModule({
  declarations: [SendMailComponent, InputMailListComponent, FilterPipe],
  exports: [SendMailComponent, InputMailListComponent],
  imports: [
    CommonModule,
    FormsModule,
    CKEditorModule,
    PipeModule,
    NgbModule,
    DateModule,
    GEDModule,
  ]
})

export class SendMailModule { }
